import React, {useState, useEffect} from "react";
import {TrackerPolicy} from "@models/tracker-policy";
import Table from "@components/purchases/Table";
import {Button, Card, Modal} from "antd";
import SearchComponent from "@components/purchases/Search";
import {NavLink} from "react-router-dom";
import whitListData from "@hocs/withListData";
import purchaseApi from "@api/purchase";
import withPaginationComponent from "@hocs/withPaginationComponent";
import __i18n from "../../intl/__i18n";
import {useSelector} from "react-redux";
import {getMainClientId} from "../../components/clients/selectors";


function useListFilter() {
  const client_id = useSelector(getMainClientId);
  return {
    client_id,
  }
}

interface PropsFromHoc {
  data: TrackerPolicy[];
  isFetched: boolean;
  currentPage: number;
  search: (params: object | null) => void;
  onDeleteItem: (id: string) => void;
}


type AllProps = PropsFromHoc ;

const ListPage: React.FC<AllProps> = (props) => {
  const {data, isFetched, currentPage, search} = props;
  const [items, setItems] = useState(data);
  
  useEffect(() => {
    setItems(data)
  }, [data]);
  
  const onChangeStatus = (status, id) => {
    Modal.confirm({
      content: __i18n("Are you sure to change the purchase's status?"),
      okText: __i18n("Yes"),
      cancelText: __i18n("No"),
      className: "delete-confirm-dialog",
      onOk: () => {
        purchaseApi.update({
            payload: [{
              value: status,
              path: "status",
              op: "replace",
              from: ""
            }],
            params: {id},
            patch: true
          })
          .then(() => {
            setItems(items.map(item => item.id === id ? ({...item, status}) : item))
          })
          .catch(() => {
            //Handle Errors
          })
      }
    });
    
  };
  
  return (
    <div>
      <div className={`toggle-button-wrapper`}>
        <NavLink to={`/purchases/create`}>
          <Button type={"primary"}>
            {__i18n("Create New Purchase")}
          </Button>
        </NavLink>
      </div>
      <div className={"page-table-wrapper"}>
        <Card className={`page-table-header`} bordered={false}>
          <SearchComponent search={search}/>
        </Card>
        
        <Table
          data={items}
          currentPage={currentPage}
          rowKey={record => record.id}
          onChangeStatus={onChangeStatus}
          loading={!isFetched}
        />
      </div>
    </div>
  );
};


export default whitListData(
  withPaginationComponent(ListPage),
  {
    fetchRequest: purchaseApi.getList,
    paginationOnScroll: false,
    useFilter: useListFilter
  }
);
